<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { browserWebcamStreamingStore } from '../../stores/browserWebcamStreaming';

const props = defineProps({
    width: { type: Number, required: false, default: 320 },
    height: { type: Number, required: false, default: 240 },
});

const store = browserWebcamStreamingStore();
const video = ref<HTMLVideoElement | null>(null);

function attach() {
    store.attachPreview(video.value);
}

onMounted(attach);
watch(() => store.stream, attach);
</script>

<template>
    <div
        class="browser-webcam-preview"
        :style="{ width: `${props.width}px`, height: `${props.height}px` }">
        <img
            v-if="store.isMock"
            class="browser-webcam-preview__image"
            :src="`data:image/jpeg;base64,${store.mockPhotoBase64}`"
            alt="Preview da webcam"
        />
        <video
            v-else
            ref="video"
            class="browser-webcam-preview__video"
            autoplay
            muted
            playsinline></video>
        <div v-if="store.status !== 'publishing' && !store.isMock" class="browser-webcam-preview__status">
            {{ store.status === 'failed' ? 'Webcam indisponível' : 'Conectando webcam' }}
        </div>
        <div v-if="store.isMock && !store.mockPhotoBase64" class="browser-webcam-preview__status">
            Webcam simulada
        </div>
    </div>
</template>

<style scoped>
.browser-webcam-preview {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: #111827;
}

.browser-webcam-preview__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.browser-webcam-preview__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.browser-webcam-preview__status {
    position: absolute;
    inset: auto 8px 8px;
    border-radius: 4px;
    padding: 40px 8px;
    background: rgba(17, 24, 39, 0.84);
    color: #ffffff;
    font-size: 12px;
    text-align: center;
}
</style>
